export default function Heater() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_3838_26494)">
                <path
                    d="M30.375 25.5L30.375 10.5C30.375 9.67157 29.7034 9 28.875 9L25.125 9C24.2966 9 23.625 9.67157 23.625 10.5L23.625 25.5C23.625 26.3284 24.2966 27 25.125 27L28.875 27C29.7034 27 30.375 26.3284 30.375 25.5Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="27" cy="13.5" r="1.125" transform="rotate(180 27 13.5)" fill="#707070" />
                <path
                    d="M23.625 24.75L23.625 11.25C23.625 10.0074 22.6176 9 21.375 9C20.1324 9 19.125 10.0074 19.125 11.25L19.125 24.75C19.125 25.9926 20.1324 27 21.375 27C22.6176 27 23.625 25.9926 23.625 24.75Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.125 24.75L19.125 11.25C19.125 10.0074 18.1176 9 16.875 9C15.6324 9 14.625 10.0074 14.625 11.25L14.625 24.75C14.625 25.9926 15.6324 27 16.875 27C18.1176 27 19.125 25.9926 19.125 24.75Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.625 24.75L14.625 11.25C14.625 10.0074 13.6176 9 12.375 9C11.1324 9 10.125 10.0074 10.125 11.25L10.125 24.75C10.125 25.9926 11.1324 27 12.375 27C13.6176 27 14.625 25.9926 14.625 24.75Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.125 24.75L10.125 11.25C10.125 10.0074 9.11764 9 7.875 9C6.63236 9 5.625 10.0074 5.625 11.25L5.625 24.75C5.625 25.9926 6.63236 27 7.875 27C9.11764 27 10.125 25.9926 10.125 24.75Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M27 27L27 30" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.125 23.625H25.875" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.125 20.25H25.875" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.875 27L7.875 30" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M11.1385 4.51941L10.7153 5.07956C10.5361 5.31662 10.6587 5.65959 10.9474 5.72951V5.72951C11.242 5.80082 11.3618 6.15464 11.1712 6.39023L10.7066 6.9645"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M15.6385 4.51941L15.2153 5.07956C15.0361 5.31662 15.1587 5.65959 15.4474 5.72951V5.72951C15.742 5.80082 15.8618 6.15464 15.6712 6.39023L15.2066 6.9645"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M20.1385 4.51941L19.7153 5.07956C19.5361 5.31662 19.6587 5.65959 19.9474 5.72951V5.72951C20.242 5.80082 20.3618 6.15464 20.1712 6.39023L19.7066 6.9645"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3838_26494">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
